import React, { useEffect } from 'react';
import {useGlobalContext} from '../Utils/ContextApi';
import TvCard from '../components/MovieCard/TvCard';
import {motion} from 'framer-motion'
import {fetchData} from '../Utils/FetchData'
import { FaSearch } from 'react-icons/fa';

function SearchTv(props) {
  const{tvResult} = useGlobalContext()
    return (
    <motion.div className='card-container'
    initial={{width:0}}
    animate={{width:"100%"}}
    exit={{x:window.innerWidth, transition: {duration:  0.1}}}>
      {tvResult.length >= 1 ? tvResult.map((item)=>{
        return(
          <TvCard {...item} key={item.id}/>
        ) 
      }) :<h1>No Result</h1>}
    </motion.div>
  )
}

export default SearchTv